<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { apiRequest } from '../services/api'
import { downloadMarkdown } from '../services/export'
import type { Conversation } from '../types'
const props=defineProps<{conversation:Conversation}>()
const emit=defineEmits<{renamed:[conversation:Conversation]}>()
const router=useRouter()
const editing=ref(false),title=ref(''),busy=ref(false),error=ref('')
function edit(){ title.value=props.conversation.title;error.value='';editing.value=true }
async function save(){
  if(!title.value.trim()||title.value.trim().length>120)return
  busy.value=true;error.value=''
  try{emit('renamed',await apiRequest<Conversation>(`/v1/conversations/${props.conversation.id}`,{method:'PATCH',body:JSON.stringify({title:title.value})}));editing.value=false}
  catch(e){error.value=e instanceof Error?e.message:'保存失败'}finally{busy.value=false}
}
async function markdown(){busy.value=true;error.value='';try{await downloadMarkdown(props.conversation.id)}catch(e){error.value=e instanceof Error?e.message:'导出失败'}finally{busy.value=false}}
function print(){window.open(router.resolve(`/print/${props.conversation.id}`).href,'_blank','noopener')}
</script>
<template>
  <div class="conversation-actions" @click.stop>
    <details><summary aria-label="对话菜单">⋯</summary><div class="conversation-menu">
      <button type="button" @click="edit">重命名</button>
      <button type="button" :disabled="busy" @click="markdown">导出 Markdown</button>
      <button type="button" @click="print">打印 / 保存 PDF</button>
    </div></details>
    <p v-if="error&&!editing" role="alert">{{error}}</p>
    <Teleport to="body"><div v-if="editing" class="rename-overlay" @click.self="editing=false">
      <form class="rename-dialog" role="dialog" aria-modal="true" aria-label="重命名对话" @submit.prevent="save">
        <h2>重命名对话</h2><label>对话名称<input v-model="title" autofocus maxlength="120" aria-label="对话名称" @keydown.esc="editing=false"></label>
        <p v-if="error" role="alert">{{error}}</p><div><button type="button" @click="editing=false">取消</button><button type="submit" :disabled="busy||!title.trim()">保存</button></div>
      </form>
    </div></Teleport>
  </div>
</template>
